<template>
    <div class="reading-component" v-if="data.type=='reading'">
        <rich-text class="reading-title" :text="data.text"/>
        <ChoiceComponent v-for="(choice,index) in data.children" :data="choice" :key="index"></ChoiceComponent>
    </div>
</template>

<script>
// 引入mixins
import mixins_config from "@/mixins/config.js";
// 引入组件
import ChoiceComponent from "../components/ChoiceComponent.vue"
import RichText from "./RichText";

export default {
    name: "ReadingComponent",
    mixins: [mixins_config],
    components: {RichText, ChoiceComponent },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {},
};
</script>
